export const inputStyles = {
  base: "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-1 px-2",
  colorInput: "w-12 h-12 rounded-full cursor-pointer overflow-hidden",
  select: "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200",
  fileInput: "mt-1 block w-full file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100",
  label: "text-gray-700 font-medium",
  container: "space-y-4 p-4 bg-white rounded-lg shadow-sm",
};
